export const convertBase64ToByteArray = (
  dataURI: any,
  withoutBase64?: boolean,
) => {
  let data = dataURI
  if (!withoutBase64) {
    const BASE64_MARKER = ';base64,'
    const base64Index = dataURI.indexOf(BASE64_MARKER) + BASE64_MARKER.length
    const base64 = dataURI.substring(base64Index)
    data = base64
  }

  const raw = window.atob(data)
  const rawLength = raw.length
  const array = new Uint8Array(new ArrayBuffer(rawLength))
  for (var i = 0; i < rawLength; i++) {
    array[i] = raw.charCodeAt(i)
  }
  return array
}
